<template>
  <div class="coupon">
    <tabHeader :isRight="true" :tabs="headTabs" @tabEvent="tabChange" @tipEvent="tipDialog" />

    <div class="coupon-box">
      <noUse v-if="currentIndex == '0'" :currentIndex="this.currentIndex" />
      <expire v-if="currentIndex == '-1'" :currentIndex="this.currentIndex" />
      <used v-if="currentIndex == '1'" :currentIndex="this.currentIndex" />
    </div>


  </div>
</template>

<script>
import tabHeader from "@/components/TabHeader";
import noUse from "./components/NoUse.vue"
import used from "./components/Used.vue"
import expire from "./components/Expire.vue"
export default {
  components: {
    tabHeader,
    noUse,
    expire,
    used
  },
  data() {
    return {
      headTabs: [
        {
          label: "未使用",
          value: "0",
        },
        {
          label: "已使用",
          value: "1",
        },
        {
          label: "已过期",
          value: "-1",
        },
      ],
      currentIndex: "0",
      
    };
  },
  
  mounted() {
  },
  methods: {
    tabChange(value) {
      this.currentIndex = value;
    },

    tipDialog() {
      this.dialogText =
        "1、同一游戏账号，仅能在一个万梦账号上使用优惠券；<br/>2、充值时，若折扣大于4.8折（如5折），通用券无法使用，需转换成万能券后使用，其他类型不受此限制；<br/>3、首充券仅首充可用，续充券仅续充可用；";
      this.$dialog.confirm({
        title: "温馨提示",
        width: "260px",
        message: this.dialogText,
        confirmButtonColor: "#FF7A3E",
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        confirmButtonText: "确定",
        messageAlign: "left",
      });
    }
    
  },
};
</script>

<style lang="scss">
.coupon {
  .coupon-box {
    padding: 20px;
    
  }
}
</style>


// WEBPACK FOOTER //
// src/views/coupon/index.vue